import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SectionMessageContainer = styled.div`
  margin-top: ${Spacing.S16};
`
